import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const photoStacks = document.querySelectorAll(".photo-stack");

  photoStacks.forEach((block) => {
    const wrapper = block.querySelector(".photo-stack--wrapper");
    const trail = block.querySelector(".photo-stack--trail");
    const galleryTrail = block.querySelector(".wp-block-gallery");
    const imageContainers = galleryTrail.querySelectorAll(".wp-block-image");

    gsap.set(block, {
      height: `${imageContainers.length * 100}dvh`,
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: "top top",
        end: "bottom bottom",
        pin: wrapper,
        scrub: 1,
        // pinSpacing: false,
        markers: false,
        toggleActions: "play none none reverse",
      },
    });

    imageContainers.forEach((image, index) => {
      let rotationAngle =
        index % 2 === 0 ? 2 + (index + 1) * 2 : -(2 + (index + 1) * 2);
      if (index === 0 || index === imageContainers.length - 1) {
        rotationAngle = 0;
      }

      let initAttrs =
        index === 0 ? { opacity: 0.4 } : { opacity: 0, yPercent: 50 };

      tl.fromTo(
        image,
        { ...initAttrs },
        {
          opacity: 1,
          yPercent: 0,
          ease: "expo.inOut",
          duration: 0.8,
          rotate: rotationAngle,
        },
        ">"
      );
    });
  });
});
